import Modal from 'utils/packages/Modal';
const topUpErrorTitle = 'The\xa0payment\xa0didn’t\xa0go through. Please\xa0try\xa0again.';
const createTopUpErrorHandler = (retry) => (userMessage) => {
    Modal.showError(userMessage || topUpErrorTitle, retry);
};
export default createTopUpErrorHandler;
